import { useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PainelTv, type SlideTv } from "@/components/tv/PainelTv";
import { useSlidesSilpiFarmaTv } from "@/features/silpi-farma/slidesTv";
import { useInteracoesPorMes, useInteracoesRecentes, useMapaClientes, useOverviewGeral, useOverviewGraficos } from "./api";
import { indiceDaTela, TELAS } from "./telas";
import { InteracoesTv } from "./telas/Interacoes";

const SECAO = "Silpi Sistema";
const PREFIXO = "home-";

const dataExtenso = new Intl.DateTimeFormat("pt-BR", { weekday: "long", day: "numeric", month: "long" });

/**
 * Modo TV da Home: as mesmas telas da Home (Geral, CS, Clientes, Sistema) em rodízio,
 * seguidas dos slides do Silpi Farma. Começa na tela de ?tela= (a aba aberta na Home)
 * e o Esc volta para a Home nessa mesma tela, se for uma das dela.
 */
export default function OverviewTv() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  // As telas buscam os próprios dados; aqui só para o rodapé ("Atualizado há…"). O React Query deduplica.
  const consultas = [
    useOverviewGeral({ autoAtualizar: true }),
    useOverviewGraficos({ autoAtualizar: true }),
    useInteracoesPorMes({ autoAtualizar: true }),
    useMapaClientes({ autoAtualizar: true }),
    useInteracoesRecentes({ autoAtualizar: true }),
  ];
  const farma = useSlidesSilpiFarmaTv("tudo");

  const slides: SlideTv[] = [
    ...TELAS.map(({ id, titulo, Componente, comInteracoes }) => ({
      id: `${PREFIXO}${id}`,
      secao: SECAO,
      titulo,
      conteudo: <Componente variante="tv" />,
      lateral: comInteracoes ? <InteracoesTv /> : undefined,
    })),
    ...farma.slides,
  ];

  const aoSair = useCallback(
    (slide: SlideTv | undefined) =>
      navigate(slide?.id.startsWith(PREFIXO) ? `/?tela=${slide.id.slice(PREFIXO.length)}` : "/"),
    [navigate],
  );

  return (
    <PainelTv
      slides={slides}
      consultas={[...consultas, ...farma.consultas]}
      subtitulo={dataExtenso.format(new Date())}
      aoSair={aoSair}
      indiceInicial={indiceDaTela(params.get("tela"))}
    />
  );
}
